//core
import { createSelector } from "@reduxjs/toolkit";

//store
import {RootState} from "../../../index";

// state
const summaryReportSelector = (state: RootState) => state.admin.agent_statistic_report;

const summaryReportOptionsSelector = (state: RootState) => state.admin.agent_statistic_report.options;
const summaryReportOptionsDataSelector = (state: RootState) => state.admin.agent_statistic_report.options.data;
const summaryReportOptionsErrorSelector = (state: RootState) => state.admin.agent_statistic_report.options.error;
const summaryReportOptionsFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.options.isFetching;

const summaryReportListSelector = (state: RootState) => state.admin.agent_statistic_report.list;
const summaryReportListDataSelector = (state: RootState) => state.admin.agent_statistic_report.list.data;
const summaryReportListErrorSelector = (state: RootState) => state.admin.agent_statistic_report.list.error;
const summaryReportListFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.list.isFetching;

const summaryReportDownloadSelector = (state: RootState) => state.admin.agent_statistic_report.download;
const summaryReportDownloadDataSelector = (state: RootState) => state.admin.agent_statistic_report.download.data;
const summaryReportDownloadErrorSelector = (state: RootState) => state.admin.agent_statistic_report.download.error;
const summaryReportDownloadFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.download.isFetching;

const summaryReportAffiliatesSelector = (state: RootState) => state.admin.agent_statistic_report.affiliates;
const summaryReportAffiliatesDataSelector = (state: RootState) => state.admin.agent_statistic_report.affiliates.data;
const summaryReportAffiliatesErrorSelector = (state: RootState) => state.admin.agent_statistic_report.affiliates.error;
const summaryReportAffiliatesFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.affiliates.isFetching;

const summaryReportTrackersSelector = (state: RootState) => state.admin.agent_statistic_report.trackers;
const summaryReportTrackersDataSelector = (state: RootState) => state.admin.agent_statistic_report.trackers.data;
const summaryReportTrackersErrorSelector = (state: RootState) => state.admin.agent_statistic_report.trackers.error;
const summaryReportTrackersFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.trackers.isFetching;

const summaryReportDealsSelector = (state: RootState) => state.admin.agent_statistic_report.deals;
const summaryReportDealsDataSelector = (state: RootState) => state.admin.agent_statistic_report.deals.data;
const summaryReportDealsErrorSelector = (state: RootState) => state.admin.agent_statistic_report.deals.error;
const summaryReportDealsFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.deals.isFetching;

const summaryReportCreativesSelector = (state: RootState) => state.admin.agent_statistic_report.creatives;
const summaryReportCreativesDataSelector = (state: RootState) => state.admin.agent_statistic_report.creatives.data;
const summaryReportCreativesErrorSelector = (state: RootState) => state.admin.agent_statistic_report.creatives.error;
const summaryReportCreativesFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.creatives.isFetching;

const summaryReportProductsSelector = (state: RootState) => state.admin.agent_statistic_report.products;
const summaryReportProductsDataSelector = (state: RootState) => state.admin.agent_statistic_report.products.data;
const summaryReportProductsErrorSelector = (state: RootState) => state.admin.agent_statistic_report.products.error;
const summaryReportProductsFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.products.isFetching;

const summaryReportManagersSelector = (state: RootState) => state.admin.agent_statistic_report.managers;
const summaryReportManagersDataSelector = (state: RootState) => state.admin.agent_statistic_report.managers.data;
const summaryReportManagersErrorSelector = (state: RootState) => state.admin.agent_statistic_report.managers.error;
const summaryReportManagersFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.managers.isFetching;

const summaryReportBrandsSelector = (state: RootState) => state.admin.agent_statistic_report.brands;
const summaryReportBrandsDataSelector = (state: RootState) => state.admin.agent_statistic_report.brands.data;
const summaryReportBrandsErrorSelector = (state: RootState) => state.admin.agent_statistic_report.brands.error;
const summaryReportBrandsFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.brands.isFetching;

const summaryReportCurrenciesSelector = (state: RootState) => state.admin.agent_statistic_report.currencies;
const summaryReportCurrenciesDataSelector = (state: RootState) => state.admin.agent_statistic_report.currencies.data;
const summaryReportCurrenciesErrorSelector = (state: RootState) => state.admin.agent_statistic_report.currencies.error;
const summaryReportCurrenciesFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.currencies.isFetching;

const summaryReportPlatformsSelector = (state: RootState) => state.admin.agent_statistic_report.platforms;
const summaryReportPlatformsDataSelector = (state: RootState) => state.admin.agent_statistic_report.platforms.data;
const summaryReportPlatformsErrorSelector = (state: RootState) => state.admin.agent_statistic_report.platforms.error;
const summaryReportPlatformsFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.platforms.isFetching;

const summaryReportColumnsDataSelector = (state: RootState) => state.admin.agent_statistic_report.columns.data;
const summaryReportColumnsErrorSelector = (state: RootState) => state.admin.agent_statistic_report.columns.error;
const summaryReportColumnsFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.columns.isFetching;

//selectors
export const selectSummaryReport = createSelector(summaryReportSelector, (report) => report);

export const selectOptions = createSelector(summaryReportOptionsSelector, (options) => options);
export const selectOptionsData = createSelector(summaryReportOptionsDataSelector, (data) => data);
export const selectOptionsError = createSelector(summaryReportOptionsErrorSelector, (error) => error);
export const selectOptionsIsFetching = createSelector(summaryReportOptionsFetchingSelector, (isFetching) => isFetching);

//columns
export const selectColumnsData = createSelector(summaryReportColumnsDataSelector, (data) => data);
export const selectColumnsError = createSelector(summaryReportColumnsErrorSelector, (error) => error);
export const selectColumnsIsFetching = createSelector(summaryReportColumnsFetchingSelector, (isFetching) => isFetching);

export const selectList = createSelector(summaryReportListSelector, (list) => list);
export const selectListDataColumnsSort = createSelector(summaryReportListDataSelector, (data) => data?.columns.filter((el: any) => el.sort === true));
const columnsFloat = [
  'poker_rake_sum',
  'poker_bonus',
  'ngr_poker',
  'poker_revenue_share_profit',
  'pkm_casino_bet_sum',
  'pkm_casino_ggr',
  'pkm_casino_bonus',
  'ngr_pkm_casino',
  'pkm_casino_revenue_share_profit',
];
export const selectListData = createSelector(summaryReportListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.reduce((acc: any[], item: any) => {
      if (item.name === 'creative_group') {
        acc.push({
          name: "creative_id",
          sort: true,
          type: "string",
        });
        acc.push({
          name: "creative_name",
          sort: true,
          type: "shortString",
        });
      } else if (item.name === 'tracker_group') {
        acc.push({
          name: "tracker_id",
          sort: true,
          type: "string",
        });
        acc.push({
          name: "tracker_description",
          sort: true,
          type: "shortString",
        });
      } else if (item.name === 'affiliate_group') {
        acc.push({
          name: "affiliate_id",
          sort: true,
          type: "clickableUserId",
        });
        acc.push({
          name: "affiliate_name",
          sort: true,
          type: "shortUsername",
        });
      } else if (item.name === 'transaction_date_for_reports') {
        acc.push({ ...item, type: 'datetime' });
      } else if (item.name === 'chief_name') {
        acc.push({ ...item, type: 'shortString' });
      } else if (item.name === 'landing_url') {
        acc.push({ ...item, type: 'link' });
      } else if (columnsFloat.includes(item.name)) {
        acc.push({ ...item, type: 'float' });
      } else if ((item.name === "anid")) {
        acc.push({ ...item, type: 'mediumString' });
      } else if ((item.name === "agent_id")) {
        acc.push({ ...item, type: 'clickableAgentId' });
      } else if ((item.name === "player_id")) {
        acc.push({ ...item, type: 'clickableExternalPlayerId' });
      } else if ((item.name === "agent_role_name")) {
        acc.push({ ...item, type: 'role' });
      } else {
        acc.push({ ...item })
      }
      return acc;
    }, []);

    return { ...data, columns: columns };
  } else {
    return data;
  }
});
export const selectListError = createSelector(summaryReportListErrorSelector, (error) => error);
export const selectListIsFetching = createSelector(summaryReportListFetchingSelector, (isFetching) => isFetching);

export const selectDownload = createSelector(summaryReportDownloadSelector, (data) => data);
export const selectDownloadData = createSelector(summaryReportDownloadDataSelector, (data) => data);
export const selectDownloadError = createSelector(summaryReportDownloadErrorSelector, (error) => error);
export const selectDownloadIsFetching = createSelector(summaryReportDownloadFetchingSelector, (isFetching) => isFetching);

export const selectAffiliates = createSelector(summaryReportAffiliatesSelector, (data) => data);
export const selectAffiliatesData = createSelector(summaryReportAffiliatesDataSelector, (data) => data);
export const selectAffiliatesError = createSelector(summaryReportAffiliatesErrorSelector, (error) => error);
export const selectAffiliatesIsFetching = createSelector(summaryReportAffiliatesFetchingSelector, (isFetching) => isFetching);

export const selectTrackers = createSelector(summaryReportTrackersSelector, (data) => data);
export const selectTrackersData = createSelector(summaryReportTrackersDataSelector, (data) => data);
export const selectTrackersError = createSelector(summaryReportTrackersErrorSelector, (error) => error);
export const selectTrackersIsFetching = createSelector(summaryReportTrackersFetchingSelector, (isFetching) => isFetching);

export const selectDeals = createSelector(summaryReportDealsSelector, (data) => data);
export const selectDealsData = createSelector(summaryReportDealsDataSelector, (data) => data);
export const selectDealsError = createSelector(summaryReportDealsErrorSelector, (error) => error);
export const selectDealsIsFetching = createSelector(summaryReportDealsFetchingSelector, (isFetching) => isFetching);

export const selectCreatives = createSelector(summaryReportCreativesSelector, (data) => data);
export const selectCreativesData = createSelector(summaryReportCreativesDataSelector, (data) => data);
export const selectCreativesError = createSelector(summaryReportCreativesErrorSelector, (error) => error);
export const selectCreativesIsFetching = createSelector(summaryReportCreativesFetchingSelector, (isFetching) => isFetching);

export const selectProducts = createSelector(summaryReportProductsSelector, (data) => data);
export const selectProductsData = createSelector(summaryReportProductsDataSelector, (data) => data);
export const selectProductsError = createSelector(summaryReportProductsErrorSelector, (error) => error);
export const selectProductsIsFetching = createSelector(summaryReportProductsFetchingSelector, (isFetching) => isFetching);

export const selectManagers = createSelector(summaryReportManagersSelector, (data) => data);
export const selectManagersData = createSelector(summaryReportManagersDataSelector, (data) => data);
export const selectManagersError = createSelector(summaryReportManagersErrorSelector, (error) => error);
export const selectManagersIsFetching = createSelector(summaryReportManagersFetchingSelector, (isFetching) => isFetching);

export const selectBrands = createSelector(summaryReportBrandsSelector, (data) => data);
export const selectBrandsData = createSelector(summaryReportBrandsDataSelector, (data) => data);
export const selectBrandsError = createSelector(summaryReportBrandsErrorSelector, (error) => error);
export const selectBrandsIsFetching = createSelector(summaryReportBrandsFetchingSelector, (isFetching) => isFetching);

export const selectCurrencies = createSelector(summaryReportCurrenciesSelector, (data) => data);
export const selectCurrenciesData = createSelector(summaryReportCurrenciesDataSelector, (data) => data);
export const selectCurrenciesError = createSelector(summaryReportCurrenciesErrorSelector, (error) => error);
export const selectCurrenciesIsFetching = createSelector(summaryReportCurrenciesFetchingSelector, (isFetching) => isFetching);

export const selectPlatforms = createSelector(summaryReportPlatformsSelector, (data) => data);
export const selectPlatformsData = createSelector(summaryReportPlatformsDataSelector, (data) => data);
export const selectPlatformsError = createSelector(summaryReportPlatformsErrorSelector, (error) => error);
export const selectPlatformsIsFetching = createSelector(summaryReportPlatformsFetchingSelector, (isFetching) => isFetching);

//Agent options
const summaryReportAgentsDataSelector = (state: RootState) => state.admin.agent_statistic_report.agents.data;
const summaryReportAgentsErrorSelector = (state: RootState) => state.admin.agent_statistic_report.agents.error;
const summaryReportAgentsFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.agents.isFetching;
export const selectAgentsData = createSelector(summaryReportAgentsDataSelector, (data) => data);
export const selectAgentsError = createSelector(summaryReportAgentsErrorSelector, (error) => error);
export const selectAgentsIsFetching = createSelector(summaryReportAgentsFetchingSelector, (isFetching) => isFetching);

//Agent Roles options
const summaryReportAgentRolesDataSelector = (state: RootState) => state.admin.agent_statistic_report.agentRoles.data;
const summaryReportAgentRolesErrorSelector = (state: RootState) => state.admin.agent_statistic_report.agentRoles.error;
const summaryReportAgentRolesFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.agentRoles.isFetching;
export const selectAgentRolesData = createSelector(summaryReportAgentRolesDataSelector, (data) => data);
export const selectAgentRolesError = createSelector(summaryReportAgentRolesErrorSelector, (error) => error);
export const selectAgentRolesIsFetching = createSelector(summaryReportAgentRolesFetchingSelector, (isFetching) => isFetching);

//Players options
const summaryReportPlayersDataSelector = (state: RootState) => state.admin.agent_statistic_report.players.data;
const summaryReportPlayersErrorSelector = (state: RootState) => state.admin.agent_statistic_report.players.error;
const summaryReportPlayersFetchingSelector = (state: RootState) => state.admin.agent_statistic_report.players.isFetching;
export const selectPlayersData = createSelector(summaryReportPlayersDataSelector, (data) => data);
export const selectPlayersError = createSelector(summaryReportPlayersErrorSelector, (error) => error);
export const selectPlayersIsFetching = createSelector(summaryReportPlayersFetchingSelector, (isFetching) => isFetching);
